/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBullhorn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 1.557v18.887l-7.023-2.963A5.008 5.008 0 0 1 10 22.001c-2.757 0-5-2.245-5-5V14H2V8h4.728zM7 14.116V17c0 1.654 1.346 3 3 3s3-1.346 3-3v-.353zm13-9.672L8 9.694v2.613l12 5.25zM6 10H4v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBullhorn as Bullhorn };
